import { getDispensaryApiBaseUrl } from "./api-base";

/** Subset of **`GET /api/v1/dispensaries/:id`** used by onboarding. */
export type DispensaryProfileBrief = {
  id: string;
  legalName: string;
  dbaName: string | null;
  onboardingCompletedAt: string | null;
};

export async function fetchDispensaryProfile(
  getToken: () => Promise<string | null>,
  dispensaryId: string,
): Promise<DispensaryProfileBrief> {
  const token = await getToken();
  if (!token) throw new Error("not_signed_in");
  const base = getDispensaryApiBaseUrl();
  const path = `/api/v1/dispensaries/${encodeURIComponent(dispensaryId)}`;
  const url = base ? `${base}${path}` : path;
  const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error(`dispensary_profile_http_${res.status}`);
  return (await res.json()) as DispensaryProfileBrief;
}
